// Tooltip.tsx
import React, { useState } from 'react';
import { Info } from 'lucide-react';

interface TooltipProps {
  message: string;
  children: React.ReactNode;
  width?: string; // optional width like "w-64", "w-48"
}

const TooltipElement: React.FC<TooltipProps> = ({ children, width, message }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="relative inline-block">
      <div
        className="flex"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {children}
      </div>
     

      {isHovered && (
        <div
          className={`absolute bottom-full left-1/2 transform -translate-x-1/2 z-50 p-4`}
        >
          <div
            className={`${width} bottom-full bg-blue-50 font-normal text-sm px-4 py-2 rounded-lg shadow-xl-0-19-40-8 border border-gray-300 z-50`}
          >
            <div
              className="bg-blue-50 font-normal text-sm rounded-lg z-50"
              dangerouslySetInnerHTML={{
                __html: message,
              }}
            ></div>
            {/* <div className={`bg-blue-50 font-normal text-sm rounded-lg z-50`}>{message}</div> */}
            {/* Triangle */}
          </div>
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full z-40 mb-5">
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.9754 12.2043C8.77413 13.1451 10.2259 13.1451 11.0246 12.2043L17.5282 4.54445C18.6313 3.24526 17.7079 1.25 16.0036 1.25H2.99641C1.29211 1.25 0.36875 3.24526 1.47182 4.54445L7.9754 12.2043Z"
                fill="#eff6ff"
              />
              <path
                d="M7.59473 12.5283C8.59308 13.7036 10.4069 13.7036 11.4053 12.5283L17.9092 4.86816C19.2879 3.24426 18.1341 0.75025 16.0039 0.75H2.99609C0.865921 0.75025 -0.287945 3.24426 1.09082 4.86816L7.59473 12.5283Z"
                stroke="#3C82F6"
                stroke-opacity="0.25"
              />
            </svg>
          </div>
        </div>
      )}
    </div>
  );
};

export default TooltipElement;
